<template>
  <section class="section_dethi">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li><router-link :to="{name: 'ebook'}">Sách điện tử</router-link></li>
          <!-- <li>
            <router-link v-if="ebooksClass && ebooksClass.bookClass && ebooksClass.bookClass.classId" :to="{ name: 'ebook-type', params: {id: ebooksClass.bookClass.classId} }" title="">
              {{ebooksClass.bookClass.name}}
            </router-link>
          </li> -->
          <li>
            <router-link v-if="ebooksClass&&ebooksClass.bookType&&ebooksClass.bookType.bookTypeId" :to="{ name: 'ebook-class', params: {id: ebooksClass.bookClass.classId, typeId: ebooksClass.bookType.bookTypeId} }" title="">
              {{ebooksClass.bookType.name}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
   <!--  <div class="book-list__filter">
      <div class="container-hts">
        <div class="book-list__filter__wrap">
          <div class="ss-banner__classes">
            <span class="ss-banner__classes__name">Lớp</span>
            <ul class="ss-banner__classes__list p-0 margin-0">
              <li v-for="(item, index2) in filters.classes">
                <a href="javascript:;" :class="{'active': item.classId===selectClass}"  @click="filterByClass(item.classId)">
                  {{ item.classNo<10 ? ('0'+item.classNo): item.classNo }}
                </a>
              </li>
            </ul>
          </div>
          <div class="ss-banner__select">
            <div class="select-custom">
              <select class="select_search secondary-color-txt border-rd-20 font-size-15 full-width" v-model="selectType" @change="filterByType($event)">
                <option value="0">Tất cả</option>
                <option v-for="(item, index) in filters.bookTypes" :key="index" :value="item.bookTypeId">{{ item.name }}</option>
              </select>
              <i class="fas fa-chevron-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div> -->
      <div class="ss-data list__box__body list__box__body--grid">
        <div class="container-hts box_content">
          <div class="row">
            <div class="item col-xl-3 col-lg-4 col-md-4 col-sm-6" v-for="(itemBook, index2) in ebooksClass.books">
              <div class="item__wrap position-rel text-center">
                <div class="item__head">
                  <router-link :to="{ name: 'ebook-detail', params: { id: itemBook.bookId, slug: itemBook.slug } }">
                    <img class="inner-img" :src="itemBook.imageUrl!=null?cdnUrl +itemBook.imageUrl.replace('Content//images','images'):''" :alt="itemBook.name" />
                  </router-link>
                </div>
                <div class="item__body">
                  <h3 class="item__name font-size-18 font-sanpro-semibold primary-color-txt">
                    <router-link :to="{ name: 'ebook-detail', params: { id: itemBook.bookId, slug: itemBook.slug } }" class="primary-color-txt">
                      {{ itemBook.name }}
                    </router-link>
                  </h3>
                  <p class="margin-0 secondary-color-txt font-size-14">Năm xuất bản: {{ itemBook.editionYear }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex';
  import {STORE_KEY} from '../_store/constants'
  import store from '../_store'
import EBookFilter from './EBookFilter'
  import { APP_CONFIG } from '@/utils/constants'
export default {
  name: 'EBookClasses',
  components: {
    EBookFilter
  },
  data() {
    return {
      filterType: 0,
      id: this.$route.params.id,
      typeId: this.$route.params.typeId,      
      cdnUrl: APP_CONFIG.cdnUrl,
      selectType: 0
    }
  },
  props: {
  },
  computed: {
    ...mapGetters({
      ebooksClass: STORE_KEY + '/ebooksClass',
      filterObj: STORE_KEY + '/ebooksFilter',
      filters: STORE_KEY + '/filters'
    }),
  },
  mounted() {
   var params={
     book_type: [],
     classes: [],
     levels : [],
     subjects : []
   }
   params.book_type.push(this.typeId);
   params.classes.push(this.id);
    // this.filterObj.book_type=[this.typeId];
    // this.filterObj.classes=[this.id];
    this.$store.dispatch(STORE_KEY + '/getEBooksClass',params);
  },
  methods:{
    thumbUrl(filename) {
      return require(`@/assets/img/${filename}`);
    },
    viewAll(type){
      this.filterType= type;
    },
    filterBooks(filterData){
      // console.log("filterBooks")
      // console.log(filterData);
      //filterData.book_type.push(this.typeId);
      //filterData.classes.push(this.id);
      this.$store.dispatch(STORE_KEY + '/getEBooksClass',filterData);
    },

    filterByType(evt) {
      this.selectType= parseInt(evt.target.value);
    }
  }
}
</script>